module.exports = __webpack_public_path__ + "img/web_development.3d45f494.webp";